import {Button, Input, ToastType} from '@sportcast/ui-react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useAppDispatch} from '../../redux/hooks';
import {Link} from 'react-router-dom';
import {v4} from 'uuid';
import validator from 'validator';
import {MessageProps} from '../../components/alert/Message';
import {requestPasswordReset} from '../../fetch/passwordApi';
import {setMessage} from '../../redux/action/messageAction';

type RequestPasswordResetProps = {
    onClick: (email: string) => void
}

const RequestPasswordReset = ({onClick}: RequestPasswordResetProps) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const [email, setEmail] = useState<string>('');
    const [validating, setValidating] = useState<boolean>(false);

    const handleChange = (_id: string, value: string | number) => {
        setEmail(String(value));
    };

    const handleClick = () => {
        setValidating(true);
        if (!validator.isEmail(email)) {
            return;
        }
        if(email.includes('@sportcast.de')||
            email.includes('@sportcast.intern')){
            dispatch(setMessage({
                i18nMessage: 'error.EMAIL_DOMAIN_NOT_ALLOWED',
                messageId: v4(),
                autoClose: true,
                type: ToastType.ERROR
            } as MessageProps));
            return;
        }

        requestPasswordReset(email, dispatch).then((response) => {
            if (!response.success) {
                dispatch(setMessage({
                    i18nMessage: 'error.ERROR_CALLING_BACKEND',
                    messageId: v4(),
                    autoClose: true,
                    type: ToastType.ERROR
                } as MessageProps));
            }
        });
        onClick(email);
    };

    const getErrorMessage = () => {
        if (!validating || validator.isEmail(email)) {
            return '';
        }
        return t('validation.INVALID_EMAIL');
    };

    return (
        <>
            <Link to={'/'}>{t('login.BACK_TO_LOGIN')}</Link>

            <h5 className="my-4">{t('forgotPassword.TITLE')}</h5>

            <Input
                id="email"
                className="mb-4"
                type={'email'}
                label={t('forgotPassword.EMAIL')}
                required={true}
                autoComplete="email"
                onChange={handleChange}
                value={email}
                errorMessage={getErrorMessage()}
            />

            <div className="explanation">
                {t('forgotPassword.INSTRUCTIONS')}
            </div>

            <div className="mt-5 text-right">
                <Button
                    id="send-link"
                    className="w-60"
                    variant="primary"
                    type="submit"
                    label={t('forgotPassword.SEND_LINK')}
                    onClick={() => handleClick()}
                />
            </div>
        </>
    );
};

export default RequestPasswordReset;